import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import RegistrationForm from '../../../../components/forms/RegistrationForm/index'
import { register } from '../../../../state/redux/actions/authActions'

const Register = () => {
  const [error, setError] = useState('')
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleSubmit = async credentials => {
    try {
      setError('')
      const userCreate = await dispatch(register(credentials))
      console.log('credentials', credentials)
      if (register.fulfilled.match(userCreate)) {
        navigate('/login')
      } else {
        setError(userCreate.payload || 'Register failed')
      }
    } catch (error) {
      console.error('Register failed:', error)
      throw error
    }
  }

  return (
    <div className="flex justify-center items-center h-screen w-screen px-4 sm:px-6">
      <div className="bg-white p-4 sm:p-6 md:p-8 rounded-lg shadow w-full max-w-[95vw] sm:max-w-md md:max-w-lg">
        <div className="flex justify-center mb-4 sm:mb-6">
          <img
            src="/assets/images/swapspace-new-logo3.png"
            alt="SwapSpace Logo"
            className="w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 object-contain"
          />
        </div>
        <RegistrationForm onSubmit={handleSubmit} error={error} />
      </div>
    </div>
  )
}

export default Register
